<template>
  <v-app>
    <router-view />
    <GlobalSnackbar />
  </v-app>
</template>

<script>
import GlobalSnackbar from './components/GlobalSnackbar.vue';
export default {
  components: { GlobalSnackbar },
  mounted() {
    document.dir = this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
  }
};
</script>
